import { render, staticRenderFns } from "./BtnCancel.vue?vue&type=template&id=0482c43c&"
import script from "./BtnCancel.vue?vue&type=script&lang=js&"
export * from "./BtnCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports